module.exports = __webpack_public_path__ + "static/media/vacation.70e80f7c.svg";